import { render } from "./DashboardTV2.vue?vue&type=template&id=09f7fb3e"
import script from "./DashboardTV2.vue?vue&type=script&lang=js"
export * from "./DashboardTV2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__